export default {
    callable: (element: HTMLElement) => {
        element.onerror = () => {
            const reportid = element.dataset.reportid;
            if (element.parentNode) {
                element.parentNode.removeChild(element);
            }
            if (reportid) {
                const parsed = parseInt(reportid);
                if (!isNaN(parsed)) {
                    reportLogoFailure(parsed);
                }
            }
        };
    },
};

function reportLogoFailure(adId: number) {
    const data = { finnkode: adId, type: 'SVGLOADERROR' };

    fetch('/distribution-front/report', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
    }).catch(() => undefined);
}
